/** Validate if is a number environment */
export function isNumberedDevEnvironment(
  hostname: string = window.location.hostname
): boolean {
  return /^dev([1-9]|1[0-9]|20)\.entry\.(staging|dev)\./.test(hostname);
}

/**
 * Whether the page follows the system colour scheme: only on localhost and on the numbered dev and
 * staging environments, so users never see dark mode before it is released.
 *
 * TODO: Remove this gate in https://faro01.atlassian.net/browse/ST-4922
 */
export function isSystemThemeEnabled(
  hostname: string = window.location.hostname
): boolean {
  return hostname === "localhost" || isNumberedDevEnvironment(hostname);
}
